module.exports = __webpack_public_path__ + "img/death-co-modern-classic-cocktails.abd1f1e4.jpg";